module.exports = __webpack_public_path__ + "static/media/gray_car.2466a69c.png";